import React from 'react';
import Input from '../components/Input';
import { strategyOptions } from './templateConstants';

export default function TemplateFields({
  register,
  errors,
  watch,
  setValue,
  policiesOptions,
  isEditMode,
  templateData,
  activeAccountId,
}) {
  return (
    <div className="mt-8 bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-gray-800 p-6">
      <input
        type="hidden"
        {...register('accountId')}
        value={isEditMode ? (templateData?.accountId || activeAccountId || '') : (activeAccountId || '')}
        readOnly
      />
      <div className="space-y-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-8">
          <div className="col-span-2 sm:col-span-1">
            <Input
              label="Use Case Name"
              placeholder="e.g. Delivery Alerts"
              required
              {...register('name')}
              error={errors.name?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              as="combobox"
              required
              label="Select an opt-out policy"
              placeholder="Select an option"
              options={policiesOptions}
              value={watch('policyId')}
              onChange={(e) => setValue('policyId', e.target.value, { shouldValidate: true })}
              error={errors.policyId?.message}
            />
          </div>

          <div className="col-span-2">
            <Input
              as="textarea"
              maxLength="500"
              label="Notes"
              placeholder="Optional notes..."
              rows={4}
              {...register('notes')}
              error={errors.notes?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              label="Inbound URL"
              type="url"
              required
              placeholder="e.g. https://example.com/inbound"
              {...register('inboundUrl')}
              error={errors.inboundUrl?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              label="Status URL"
              type="url"
              required
              placeholder="e.g. https://example.com/status"
              {...register('statusUrl')}
              error={errors.statusUrl?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              as="select"
              required
              label="Routing strategy"
              options={strategyOptions}
              {...register('routingStrategy')}
              error={errors.routingStrategy?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              type="number"
              required
              label="Time to live (seconds)"
              placeholder="e.g. 3600"
              {...register('ttl')}
              error={errors.ttl?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              label="Route"
              label_description="Check if you want to enable routing"
              as="checkbox"
              {...register('route')}
              error={errors.route?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              label="Use sticky sender"
              label_description="Enable sticky routing"
              as="checkbox"
              {...register('sticky')}
              error={errors.sticky?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              label="Use alternative vendor on failure"
              label_description="Retry with alternate vendor on failure"
              as="checkbox"
              {...register('retryAlternateVendor')}
              error={errors.retryAlternateVendor?.message}
            />
          </div>

          <div className="col-span-2 sm:col-span-1">
            <Input
              label="Redact PII"
              label_description="Redact sensitive data"
              as="checkbox"
              {...register('redact')}
              error={errors.redact?.message}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
